import { SharedModule } from "./../shared/shared.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ProvideMenuRoutingModule } from "./provide-menu-routing.module";
import { SelectMenuComponent } from "./select-menu/select-menu.component";
import { SelectFeaturesComponent } from "./select-features/select-features.component";
import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { MultiSelectModule } from "primeng/multiselect";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [SelectMenuComponent, SelectFeaturesComponent],
  imports: [
    CommonModule,
    ProvideMenuRoutingModule,
    SharedModule,
    PrimeNgModule,
    MultiSelectModule,
    HttpClientModule,
    FormsModule,
  ],
})
export class ProvideMenuModule {}
